export const config = {
    SERVICE_ID: 'service_ta3ss8i',
    TEMPLATE_ID: 'template_nsewxeq',
    PUBLIC_KEY: 'CUOSi8wL3BnG8nuZE'
}